/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-rss': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M5 11.25A3.761 3.761 0 001.25 15 3.761 3.761 0 005 18.75 3.761 3.761 0 008.75 15 3.761 3.761 0 005 11.25zm0 6.25A2.507 2.507 0 012.5 15c0-1.375 1.125-2.5 2.5-2.5s2.5 1.125 2.5 2.5-1.125 2.5-2.5 2.5zM18.75 15H17.5C17.5 8.125 11.875 2.5 5 2.5V1.25c7.563 0 13.75 6.188 13.75 13.75zm-5 0H12.5c0-4.125-3.375-7.5-7.5-7.5V6.25c4.813 0 8.75 3.938 8.75 8.75z"/>'
  }
})
